__turbopack_context__.v({
  "helios-faq-section": "domQfG_helios-faq-section",
  "helios-faq-section--tone-inverse": "domQfG_helios-faq-section--tone-inverse",
  "helios-faq-section__container": "domQfG_helios-faq-section__container",
  "helios-faq-section__content": "domQfG_helios-faq-section__content",
  "helios-faq-section__grid": "domQfG_helios-faq-section__grid",
  "helios-faq-section__header": "domQfG_helios-faq-section__header",
  "helios-faq-section__title": "domQfG_helios-faq-section__title",
});
